import { render, staticRenderFns } from "./Registration.vue?vue&type=template&id=62f9f023"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"
import style0 from "./Registration.vue?vue&type=style&index=0&id=62f9f023&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../repos/mylovelyladyhere.com/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports